// imports

import { toggleModal } from '../utils/modal';

const technicalInfo = document.querySelector('.product__tech-information');

(() => {
  if (technicalInfo) {
    const modal = technicalInfo.querySelector('.modal');
    if (modal) {
      const button = technicalInfo.querySelector('.product__tech-footer-link');
      toggleModal(modal, button);
    }
  }
})();
